import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './button.component.module.styl';

import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

interface ButtonIconProps {
    right?: boolean,
    children?: ReactNode,
}

export function ButtonIcon({
    right,
    children,
}: ButtonIconProps) {

    const iconClasses = classNames('button__icon', {
        button__icon_right: right,
    });


    return children ? (
        <span className={iconClasses}>
            {children}
        </span>
    ) : null;
}
